import React, { useState, useEffect } from 'react'
import styles from './AIPlatformBanner.module.css'
import { Button } from 'react-bootstrap'
import { useAIPlatformSource } from '../../../hooks/useAIPlatformSource'

const AI_PLATFORM_CONFIG = {
  ChatGPT: {
    name: 'ChatGPT',
    url: 'https://chromewebstore.google.com/detail/publish-chatgpt-code-by-t/glbdafgncpjkikblehhdoefdgokahogk'
  },
  Claude: {
    name: 'Claude',
    url: 'https://helpdesk.tiiny.host/en/article/how-to-connect-tiiny-host-to-claude-with-mcp-14z1okp/'
  },
  Grok: {
    name: 'Grok',
    url: 'https://helpdesk.tiiny.host/en/article/use-tiiny-host-in-grok-gsxa9c/'
  },
  Gemini: {
    name: 'Gemini',
    url: 'https://chromewebstore.google.com/detail/publish-google-gemini-cod/eaifdocaeghbhhmaengoaiaocfgmjgof?authuser=0&hl=en&pli=1'
  }
}

const AIPlatformBanner = () => {
  const [show, setShow] = useState(false)
  const aiPlatformSource = useAIPlatformSource()
  const isPluginPlatform = aiPlatformSource === 'Claude' || aiPlatformSource === 'Grok'

  useEffect(() => {
    if (aiPlatformSource && AI_PLATFORM_CONFIG[aiPlatformSource]) {
      const delayTimer = setTimeout(() => {
        setShow(true)
      }, 2500)

      return () => clearTimeout(delayTimer)
    }
  }, [aiPlatformSource])

  const handleClose = () => {
    setShow(false)
    sessionStorage.setItem('ai-platform-banner-dismissed', 'true')
  }

  const handleCTAClick = () => {
    if (aiPlatformSource && AI_PLATFORM_CONFIG[aiPlatformSource]) {
      window.open(AI_PLATFORM_CONFIG[aiPlatformSource].url, '_blank')
      setShow(false)
      sessionStorage.setItem('ai-platform-banner-dismissed', 'true')
    }
  }

  if (sessionStorage.getItem('ai-platform-banner-dismissed') === 'true') {
    return null
  }

  if (!show || !aiPlatformSource || !AI_PLATFORM_CONFIG[aiPlatformSource]) {
    return null
  }

  return (
    <div className={`${styles.page} ${styles['slide-fwd-center']}`}>
      <div className={styles.container}>
        <div className={styles.content}>
          <span className={styles.title}>
            🚀{' '}
            {isPluginPlatform
              ? `Use Tiiny Host inside ${AI_PLATFORM_CONFIG[aiPlatformSource].name}`
              : `Publish directly from ${AI_PLATFORM_CONFIG[aiPlatformSource].name}`}
          </span>
          <span className={styles.description}>
            {isPluginPlatform
              ? `Publish, update, and manage your sites directly inside ${AI_PLATFORM_CONFIG[aiPlatformSource].name}.`
              : `Install our Chrome extension to publish your code instantly from ${AI_PLATFORM_CONFIG[aiPlatformSource].name}`}
          </span>
        </div>
        <Button onClick={handleCTAClick} className={styles.btn} variant="outline-light">
          {isPluginPlatform ? 'Set up plugin' : 'Get Extension'}
        </Button>
      </div>
    </div>
  )
}

export default AIPlatformBanner
